import React, { forwardRef, useImperativeHandle } from 'react';
import { Modal, Form, Input, Radio } from 'antd';

const { TextArea } = Input;

export type DeclineModalFormProps = {
  open?: boolean;
  confirmLoading?: boolean;
  onCancel?: (e: React.MouseEvent<HTMLElement>) => void;
  onDecline?: (e: React.MouseEvent<HTMLElement>) => void;
};

export type DeclineModalFormRef = {
  validateFields: () => Promise<any>;
  resetFields: () => void;
};

const DeclineModalForm = forwardRef<DeclineModalFormRef, DeclineModalFormProps>((props, ref) => {
  const { open, confirmLoading, onCancel, onDecline } = props;
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    validateFields: () => form.validateFields(),
    resetFields: () => form.resetFields(),
  }));

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  return (
    <Modal
      open={open}
      title='Angebot ablehnen'
      okText='Ablehnen'
      cancelText='Abbrechen'
      onCancel={onCancel}
      onOk={onDecline}
      confirmLoading={confirmLoading}
    >
      <Form form={form} layout='vertical'>
        <Form.Item
          label='Grund'
          name='reason'
          rules={[{ required: true, message: 'Bitte gib einen Grund an' }]}
        >
          <Radio.Group>
            <Radio style={radioStyle} value={'PRICE_TOO_HIGH'}>
              Preis zu hoch
            </Radio>
            <Radio style={radioStyle} value={'QUALITY_TOO_LOW'}>
              Qualität zu niedrig
            </Radio>
            <Radio style={radioStyle} value={'FOUND_OTHER_SUPPLIER'}>
              Anderen Lieferanten gefunden
            </Radio>
            <Radio style={radioStyle} value={'NO_MORE_DEMAND'}>
              Keinen Bedarf mehr
            </Radio>
            <Radio style={radioStyle} value={'OTHER_REASON'}>
              Anderer Grund
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label='Anmerkung' name='note'>
          <TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
});

DeclineModalForm.displayName = 'DeclineModalForm';

export default DeclineModalForm;
